import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material'

import FileInput from 'src/Component/FileInput'
import InputField from 'src/Component/InputField'

import SimpleModal from 'src/Component/SimpleModal'
import { Controller } from 'react-hook-form'
import useUploadExercise from './useUploadExercise'
import SimpleDropdown from 'src/Component/SimpleDropdown'
import { timeOptions, trainingLevelOptions } from 'src/utils/constants'

type UploadExerciseModalProps = {
  open: boolean
  onClose: () => void
  successCallback: () => void
}
const UploadExerciseModal = ({ open, onClose, successCallback }: UploadExerciseModalProps) => {


  const { file, handleFileChange, control, errors, onSubmit, isLoadingUploadExercise } = useUploadExercise({
    successCallback,
  })

  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            <FileInput
              type='video'
              title='You can click me to upload files!'
              discription='Support for video file formats (.mp4, .wav, .mkv)'
              name='fileuplaod'
              value={file}
              onChange={handleFileChange}
              showPreview
            />

            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='name'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Exercise Name'
                        placeholder='Enter exerise name'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.name}
                        required
                      />
                      {!!errors.name && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.name.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='equipmentNeeded'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Equipment Needed'
                        placeholder='Enter Equipment Needed'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.equipmentNeeded}
                        required
                      />
                      {!!errors.equipmentNeeded && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.equipmentNeeded.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='time'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        name={field.name}
                        value={field.value}
                        label={'Time'}
                        options={timeOptions}
                        onChange={field.onChange}
                        // error={!!errors.time}
                        placeholder='Select Time'
                        required
                      />

                      {!!errors.time && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.time.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='trainingLevel'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <SimpleDropdown
                        name={field.name}
                        value={field.value}
                        label={'Training Level'}
                        options={trainingLevelOptions}
                        onChange={field.onChange}
                        // error={!!errors.trainingLevel}
                        placeholder='Training Level'
                        required
                      />
                      {!!errors.trainingLevel && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.trainingLevel.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='instruction'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        multiline
                        rows={4}
                        label='Instruction'
                        placeholder='Enter the Instruction'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.instruction}
                        required
                      />
                      {!!errors.instruction && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.instruction.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Button variant='contained' color='primary' type='submit' disabled={isLoadingUploadExercise}>
              {isLoadingUploadExercise ? <CircularProgress size={25} color='error' /> : 'UPLOAD WORKOUT'}
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default UploadExerciseModal;
